// extracted by mini-css-extract-plugin
export default {"contentBodyDragging":"SortableItem_contentBodyDragging__WPR9H","contentBody":"SortableItem_contentBody__M5B2b"};